export default "__VITE_ASSET__BpjWop3n__"